/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import UiBookingPriceTablesBaseComponent from 'uplisting-frontend/components/ui/booking/price/tables/-base';

export default class UiBookingPriceTablesGuestInvoicesComponent extends UiBookingPriceTablesBaseComponent {
  @cached
  get invoicesWithId(): ModelRegistry['guest-invoice'][] {
    return this.booking?.guestInvoices.filter((invoice) => invoice.id);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Tables::GuestInvoices': typeof UiBookingPriceTablesBaseComponent;
  }
}
